// src/pages/AuthPage.js
//
// Standalone login page at /auth. Uses the same OtpAuth component that
// ResultCTA embeds inline, and the same account gate as SignInModal.js
// (calculator/triage "Returning? Sign in") — one auth mechanism, one
// "must already have an account" rule, three places it's used.
//
// Replaces the previous password-based sign-in/sign-up/reset flow entirely.
// No password step exists anymore, so there's nothing to "forget" or
// reset. signInWithOtp itself would happily create a new account for any
// email, but this page — like SignInModal — is a sign-in surface, not a
// signup surface: accounts are created by saving a calculator estimate or
// triage snapshot, not by visiting /auth. requireExistingAccount (from
// src/lib/accountGate.js) enforces that here exactly the same way it does
// in SignInModal, rather than this page silently allowing account creation
// on its own.
//
// Note: ResetPasswordPage.js (routed at /reset-password in App.js) is no
// longer linked from anywhere in this flow. Left untouched rather than
// deleted, since any pre-existing password-based accounts could still use
// it — worth a deliberate decision on whether to retire that route
// entirely, not something to silently remove here.

import React from 'react'
import { useNavigate } from 'react-router-dom'
import OtpAuth from '../components/OtpAuth'
import { requireExistingAccount } from '../lib/accountGate'

const NOT_FOUND_MESSAGE =
  'No account found for that email. Save an estimate or complete your snapshot first to create your account.'

export default function AuthPage() {
  const navigate = useNavigate()

  function handleSuccess() {
    // Let HomeRedirect decide consumer vs. partner routing rather than
    // duplicating that logic a third time here.
    navigate('/')
  }

  function beforeSend(email) {
    return requireExistingAccount(email, NOT_FOUND_MESSAGE)
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card-header">
          <div className="u-wordmark-on-dark">Hola<span>Sam</span></div>
        </div>

        <div className="auth-card-body">
          <h2 className="auth-heading">Sign in</h2>
          <p className="auth-subheading">
            Enter your email — we'll send a code to sign in. No password needed.
          </p>
          <OtpAuth beforeSend={beforeSend} onSuccess={handleSuccess} submitLabel="Sign in" />
        </div>
      </div>
    </div>
  )
}